import React, { useState } from "react";
import { useSelector } from "react-redux";
import MainChartContainer from "../MainChartContainer/MainChartContainer";
import Grid from "../Grid/Grid";
import ColdStart from "../ColdStart/ColdStart";
import { Container } from "./ChartInterfaceStyles";
import HomeInterface from "../Home/HomeInterface/HomeInterface";

export default function ChartInterface({ show }) {
  const display = useSelector(({ display }) => display.display);

  // useState hooks
  const [help, setHelp] = useState(null);

  return (
    <Container>
      {
        {
          chart: <MainChartContainer show={true} />,
          grid: <Grid />,
          coldStart: <ColdStart help={help} setHelp={setHelp} />,
          home: <HomeInterface />,
        }[display]
      }
    </Container>
  );
}
